/*
 * @Author: lyx
 * @Date: 2024-08-15 14:25:17
 * @LastEditors: lyx
 * @LastEditTime:  2024-08-15 14:25:17
 * @FilePath: /dbrank_b/src/routes/visualChart/P29/index.js
 */

import React from "react";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import s from "./index.css";
import Stage from "../components/Stage";
import setChart from "./chart";
import Chart from "../components/Chart";
import { Title29 } from "../components/Titles";
import TooltipDrawer from "../components/TooltipDrawer";
import Form from "./Form";
import DBTable from "../components/DBTable";
import SelectLogo from "../components/SelectLogo";
import { applyThousands } from "../utils";

class P29 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chartList: [],
      brandList: [],
      chartColorList: []
    };
  }
  getMedian = (numbers) =>{
    console.log(numbers / 2);
    console.log(Math.ceil(numbers / 2));
    return Math.ceil(numbers / 2)
  }
  render() {
    const { chartList, brandList, chartColorList } = this.state;
    const width = 1210 / chartList.length;
    let redIndices = brandList.findIndex(item => item === "安踏");
    console.log(redIndices);
   
    return (
      <Stage>
        <Title29 pageNumber="1.11">安踏VS竞品 | 全网好感度对比分析</Title29>
        <div className={s.content}>
          <div>
            <div contentEditable className={s.subTitle}>
              安踏排名第五，特步第一；推荐类内容中，李宁第一；差评和反感类内容中，耐克最多
            </div>
            <div contentEditable className={s.des}>
              <span className={s.emphasis}>安踏</span>的好感度为<span className={s.emphasis}>91.94%</span>，在九品牌中排名第五。安踏的负向内容共计<span className={s.emphasis}>12,031条</span>，排名第三；推荐类内容低于李宁、特步和耐克；好感类内容位居第二，低于耐克。竞品中，特步、361度和斐乐的表现较好，负向内容较少。建议安踏从进一步提升推荐类内容数量方面来提升口碑。
            </div>
            {/* <div contentEditable className={s.des}>
              XXX
            </div> */}
          </div>

          <div className={s.uiWrapper}>
          <div className={s.tableWrapper}>
                <TooltipDrawer style={{marginTop: "-17px"}} formContent={<Form onChange={values => this.setState({ ...values })} />}>

                  <div className={s.tableBox}>
                    <ul className={s.tableBox_ul}>
                      {
                        chartList.length > 0 ?
                        <li>{chartList[chartList.length -1].name}</li> 
                        :null
                      }
                      {
                        chartList.length > 0 ?
                        chartList[chartList.length -1].list.map((item, index) => (
                          // <li key={index} style={{ color: index+1 === this.getMedian(chartList[chartList.length -1].list.length) ? 'red' : '#000'}}>{item}</li> 
                          <li style={{height: 80 / chartList[chartList.length -1].list.length +'%'}} key={index}>
                            <div  className={index === redIndices && s.centerText}>{item}</div>
                          </li> 
                        ))
                        :null
                      }
                    </ul>
                  </div>
                </TooltipDrawer>
              </div>
            <div className={s.chartWrapper}>
              {/* <TooltipDrawer
                style={{ width: "100%", height: "100%" }}
                formContent={
                  <Form onChange={(values) => this.setState({ ...values })} />
                }
              > */}
                <Chart
                  isShow
                  options={setChart({
                    chartList: chartList,
                    brandList: brandList,
                    color: chartColorList,
                  })}
                />
              {/* </TooltipDrawer> */}
            </div>
          </div>
        </div>
      </Stage>
    );
  }
}

export default withStyles(s)(P29);



// WEBPACK FOOTER //
// src/routes/visualChart/P29/index.js